import { makeRoute } from "@/lib/makeRoute";
export const Route = makeRoute("/", "fr", "home");
